export default {
  apiUrl: 'http://yoursite.com/api/',
};

const siteConfig = {
  siteName: 'CLAIM',
  siteIcon: 'ion-flash',
  footerText: 'Claim system ©2019 Created by AIST',
};
const themeConfig = {
  topbar: 'themedefault',
  sidebar: 'themedefault',
  layout: 'themedefault',
  theme: 'themedefault',
};
const language = 'english';

const jwtConfig = {
  fetchUrl: '/api/',
  secretKey: 'secretKey',
};

const constant = {
  fixedDigital: 3,
};

export { siteConfig, language, themeConfig, jwtConfig, constant };
